import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class MetaEventService {
  constructor() {}
  addMetaLeadScript(leadSource: string, resultCode: any) {
    if (
      leadSource === "041S" &&
      (resultCode?.toLocaleLowerCase() === "sold" ||
        resultCode?.toLocaleLowerCase() === "sold f")
    )
      (window as any).fbq("track", "Lead");
  }
}
